"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTilde(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M17.551 20.4c.124-.109 6.295-8.63 6.304-8.763.01-.133-4.913-7.649-5.102-7.637-.126.008-2.359 2.906-6.698 8.693C7.625 6.89 5.356 3.992 5.245 4 5.082 4.013-.003 11.275 0 11.637c.004.361 6.367 8.618 6.605 8.764.238.146 10.823.11 10.946 0zM5.264 5.26c.042-.002 6.67 9.079 6.8 9.082.129.003 6.64-9.084 6.693-9.083.053.001 4.105 6.242 4.1 6.31-.007.114-5.965 8.028-5.97 8.032-.055.05-9.666.057-9.758 0-.215-.132-6.125-7.644-6.13-7.975 0-.13 4.224-6.365 4.265-6.367z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgTilde;
exports.default = _default;